import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
button, input, textarea, select {
    font-family: inherit;
  }

  body {
    background-color:${({ theme }) => theme.colors.background};
  }

  ::selection {
    background: ${({ theme }) => theme.colors.primary_100};
  }

  /* скроллбар */
  ::-webkit-scrollbar {
    width: 8px;       
    height: 8px;      
  }

  /* Фон дорожки */
  ::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 8px;
  }

  /* Ползунок */
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.scrollbar};
    border-radius: 8px;
  }

  /* Ползунок при наведении */
  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.scrollbarHover};;
  }

  //---кастомные стили для бокового меню---
  .tabview-custom .p-tabview {
    height: 100%;
    display: flex;
  }

  .tabview-custom .css-ewdv3l {
    height: 100%;
  }

  .tabview-custom .css-vj11vy.ps-menu-root {
    height: 100%;
  }

  .tabview-custom .p-tabview .p-tabview-panels {
    background: transparent !important;
    padding: 0 !important;
    border: none !important;
    border-bottom-right-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    width: 100% !important;
  }

  .tabview-custom .p-tabview .p-tabview-nav li {
    min-width: 50px;
  }

  .tabview-custom .p-tabview .p-tabview-nav li :focus {
    outline: none;
  }

  .css-1nangw0 {
    border-color: ${({ theme }) => theme.colors.menuBorder} !important;
  }


  /* Сбросы стилей для PrimeReact */
  @layer reset, primereact, my-customizations;

  @layer my-customizations {
    /* --- Inputs --- */
    .p-inputtext {
      background: transparent !important;

      &:hover{
        border-color: #3b82f6 !important;
      }

      &:focus{
        border-color: #3b82f6 !important;
      }
    }

    /* --- Tree --- */
    .p-tree {
      padding: 0.2rem; 
      color: ${({ theme }) => theme.colors.textSecondary} ;
    }

    .p-treenode-content {
      font-size: 0.9rem;
    }

    /* --- SideMenu --- */
    .css-1q702fi {
      border-color: ${({ theme }) => theme.colors.menuBorder} !important;
    }

    /* --- TabMenu --- */
    .p-tabmenu .p-tabmenu-nav .p-tabmenuitem.p-highlight .p-menuitem-link {
      border-color: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.primary};
    }
      
    .p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link:not(.p-disabled):focus-visible {
      outline: 0 none;
      outline-offset: 0;
      box-shadow: inset 0 0 0 0.2rem ${({ theme }) => theme.colors.primary};
    }
      
    .p-tabmenu .p-tabmenu-nav .p-tab-menuitem .p-menuitem-link {
      height: 100%;
      padding: 1rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
      
    .p-menuitem-link {
      padding: 1rem;
    }
      
    /* --- TabView --- */
    .p-link:focus-visible {
      outline: 0 none;
      outline-offset: 0;
      box-shadow: 0 0 0 0.2rem ${({ theme }) => theme.colors.primary};
    }
      
    .p-tabview .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus-visible {
      outline: 0 none;
      outline-offset: 0;
      box-shadow: inset 0 0 0 0.2rem ${({ theme }) => theme.colors.primary};
    }
      
    /* --- общие классы для панелей --- */
    .tabpanel-content {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      color: ${({ theme }) => theme.colors.text};
      padding-bottom: 4rem;
    }
      
    .tabpanel-input-wrapper {
      display: flex;
      width: 100%;
      gap: 2rem;
      align-items: center;
    }
      
    .tabpanel-input-wrapper label {
      font-size: 0.9rem;
    }
      
    .tabpanel-input-wrapper-p {
      line-height: normal;
      margin: 0;
      font-size: 0.9rem;
      width: 8rem;
    }
      
    .p-tabmenu {
      overflow: visible;
    }

    .p-tabview .p-tabview-panels {
      padding: 0 !important;
    }

    /* --- multiselect --- */
    .p-multiselect {
      background-color: transparent !important;
      // border: 1px solid ${({ theme }) => theme.colors.inputBorderMedium};
      color: ${({ theme }) => theme.colors.textSecondary};
    }

    .p-multiselect-panel,
    .p-dropdown-panel,
    .p-overlaypanel,
    .p-menu,
    .p-tieredmenu,
    .p-contextmenu,
    .p-autocomplete-panel,
    .p-datepicker,
    .p-dialog {
      background: ${({ theme }) => theme.colors.background} !important;
      color: ${({ theme }) => theme.colors.textSecondary} !important;
      border-color: ${({ theme }) => theme.colors.borderColor} !important;
    }

    .p-multiselect-panel .p-multiselect-header,
    .p-dropdown-panel .p-dropdown-header,
    .p-autocomplete-panel .p-autocomplete-header,
    .p-dialog .p-dialog-header,
    .p-dialog .p-dialog-content,
    .p-dialog .p-dialog-footer {
      background: ${({ theme }) => theme.colors.background} !important;
      color: ${({ theme }) => theme.colors.textSecondary} !important;
      border-color: ${({ theme }) => theme.colors.borderColor} !important;
    }

    .p-multiselect-panel .p-multiselect-items .p-multiselect-item,
    .p-dropdown-panel .p-dropdown-items .p-dropdown-item,
    .p-menu .p-menuitem > .p-menuitem-content .p-menuitem-link,
    .p-tieredmenu .p-menuitem > .p-menuitem-content .p-menuitem-link,
    .p-contextmenu .p-menuitem > .p-menuitem-content .p-menuitem-link {
      color: ${({ theme }) => theme.colors.textSecondary} !important;
    }

    .p-multiselect-panel .p-multiselect-items .p-multiselect-item:not(.p-highlight):not(.p-disabled):hover,
    .p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover,
    .p-menu .p-menuitem:not(.p-highlight):not(.p-disabled) > .p-menuitem-content:hover,
    .p-tieredmenu .p-menuitem:not(.p-highlight):not(.p-disabled) > .p-menuitem-content:hover,
    .p-contextmenu .p-menuitem:not(.p-highlight):not(.p-disabled) > .p-menuitem-content:hover {
      background: ${({ theme }) => theme.colors.treeNodeHover} !important;
      color: ${({ theme }) => theme.colors.text} !important;
    }

    .p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight,
    .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
      background: ${({ theme }) => theme.colors.select} !important;
      color: ${({ theme }) => theme.colors.textSecondary} !important;
    }

    .p-multiselect-items-wrapper {
      max-height: 100% !important;
    }

    /* --- chips --- */
    .p-multiselect.p-multiselect-chip .p-multiselect-token {
      background:  ${({ theme }) => theme.colors.chip};
      color: ${({ theme }) => theme.colors.textSecondary};
    }

    /* --- button --- */
    .p-button {
      background-color: ${({ theme }) => theme.colors.button};
      border:none;
      color: ${({ theme }) => theme.colors.white};
      font-size: 0.9rem;  
      justify-content: center;
      transition: all 0.2s;    

      &:hover {
        opacity:0.8;
      }
    }

    .p-button-text {
      background-color: transparent;
      color: ${({ theme }) => theme.colors.buttonText};

      &:hover {
        opacity: 1;
        background-color: ${({ theme }) => theme.colors.lightGrey};
      }

      &.p-button-danger {
        color: #dc2626;
      }

      &.p-button-success {
        color: #16a34a;
      }
    }

    .p-button-outlined {
      background-color: transparent;
      border: 1px solid ${({ theme }) => theme.colors.button};
      color: ${({ theme }) => theme.colors.buttonText};

      &:hover {
        background-color: ${({ theme }) => theme.colors.buttonHover};
      }
    }

    .p-button-label {
      font-weight: 500;
    }

    /* --- RadioButton --- */
    .p-radiobutton.p-highlight .p-radiobutton-box {
      border-color: ${({ theme }) => theme.colors.logoAccent};
      background: ${({ theme }) => theme.colors.logoAccent};
  }

  .p-component {
    font-size:  ${({ theme }) => theme.typography.body.fontSize};
  }  
  }
`;
